import React, { useEffect } from 'react';
import { shape } from 'prop-types';
import Field from '../../../components/Field/Field';
import { ROL } from '../../../lib/role.enum';

const DatosPersonalesConsulta = ({ data }) => {
  const filterDenunciante = (usuarios) => {
    const denunciante = usuarios.filter((usuario) => usuario.role.name === ROL.DENUNCIANTE);
    return denunciante[0].user;
  };

  useEffect(() => {
    filterDenunciante(data.users);
  }, []);

  const { name, lastname1, lastname2, phone, document, email, position, address, documentType } = filterDenunciante(data.users);

  return (
    <div className="c-sii-datos-personales-consulta">
      <h2>Datos personales</h2>
      <div>
        <div className="o-grid">
          <div className="o-grid__row">
            <div className="o-grid__col-4">
              <Field condensed label="Nombre" tooltipFieldContent={name}>
                {name || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Primer apellido" tooltipFieldContent={lastname1}>
                {lastname1 || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Segundo apellido" tooltipFieldContent={lastname2}>
                {lastname2 || '-'}
              </Field>
            </div>
          </div>
          <div className="[ o-grid__row ][ u-mt-16 ]">
            <div className="o-grid__col-4">
              <Field condensed label="Telefono" tooltipFieldContent={phone}>
                {phone || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Tipo de documento" tooltipFieldContent={documentType}>
                {documentType || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Documento de identidad" tooltipFieldContent={document}>
                {document || '-'}
              </Field>
            </div>
          </div>
          <div className='[ o-grid__row ][ u-mt-16 ]'>
            <div className="o-grid__col-4">
              <Field condensed label="Correo electrónico" tooltipFieldContent={email}>
                {email || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Cargo" tooltipFieldContent={position}>
                {position || '-'}
              </Field>
            </div>
            <div className="o-grid__col-4">
              <Field condensed label="Dirección" tooltipFieldContent={address}>
                {address || '-'}
              </Field>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DatosPersonalesConsulta.propTypes = {
  data: shape({}),
};
DatosPersonalesConsulta.defaultProps = {
  data: null,
};

export default DatosPersonalesConsulta;
